/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  GetConversionQuote200,
  GetConversionQuoteBody,
  ExecuteQuotedTrade200,
  ExecuteQuotedTrade400,
  ExecuteQuotedTradeBody
} from './schema'



/**
 * Convert from one fungible asset to another and settle transactions without ever taking assets out of custody.
 * @summary Get a Quote
 */
export const getConversionQuote = (
    getConversionQuoteBody: GetConversionQuoteBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetConversionQuote200>> => {
    return axios.post(
      `/conversions/quote`,
      getConversionQuoteBody,options
    );
  }



    export type GetConversionQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof getConversionQuote>>>
    export type GetConversionQuoteMutationBody = GetConversionQuoteBody
    export type GetConversionQuoteMutationError = AxiosError<unknown>

    export const useGetConversionQuote = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConversionQuote>>, TError,{data: GetConversionQuoteBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConversionQuote>>, {data: GetConversionQuoteBody}> = (props) => {
          const {data} = props ?? {};

          return  getConversionQuote(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof getConversionQuote>>, TError, {data: GetConversionQuoteBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Execute a trade that has been previously quoted
 * @summary Execute a trade
 */
export const executeQuotedTrade = (
    executeQuotedTradeBody: ExecuteQuotedTradeBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ExecuteQuotedTrade200>> => {
    return axios.post(
      `/conversion/execute`,
      executeQuotedTradeBody,options
    );
  }



    export type ExecuteQuotedTradeMutationResult = NonNullable<Awaited<ReturnType<typeof executeQuotedTrade>>>
    export type ExecuteQuotedTradeMutationBody = ExecuteQuotedTradeBody
    export type ExecuteQuotedTradeMutationError = AxiosError<ExecuteQuotedTrade400>

    export const useExecuteQuotedTrade = <TError = AxiosError<ExecuteQuotedTrade400>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeQuotedTrade>>, TError,{data: ExecuteQuotedTradeBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeQuotedTrade>>, {data: ExecuteQuotedTradeBody}> = (props) => {
          const {data} = props ?? {};

          return  executeQuotedTrade(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof executeQuotedTrade>>, TError, {data: ExecuteQuotedTradeBody}, TContext>(mutationFn, mutationOptions)
    }
    